export default "__VITE_ASSET__DLxA_8sM__"